import { NavLink } from 'react-router-dom'
import { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import isLink from '../../../theme/styles/isLink'

const Link = styled(NavLink)<ILinkProps>`
  ${isLink};

  width: 100%;

  & {
    color: black;
    text-decoration: none;
  }

  ${isNot('nested')`
    padding: 0 ${({ size }) => (size ? 1.25 * size : 1.25)}em 0 ${({ size }) =>
    size ? size : 1}em;
  `}

  &.active {
    color: ${(props: ITheme) => props.theme.colors.primary} !important;
    li {
      color: ${(props: ITheme) => props.theme.colors.primary} !important;
      font-weight: bold;
    }
    ${isNot('nested')`
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
    `}
    & > div > span {
      color: ${(props: ITheme) => props.theme.colors.primary} !important;
    }
    & > a {
      color: ${(props: ITheme) => props.theme.colors.primary} !important;
    }
    font-weight: bold;
  }
`

export default Link


export interface ILinkProps {
  nested?: boolean
  size?: number
  exact?: boolean
}
